<template>
  <div class="container product-list">
    <h1 class="header-title">รายการ</h1>
    <div v-if="ready">
      <div class="product-list-item-wrapper row flex">
        <div class="col-sm-4 flex" v-for="productId in products">
          <product-list-item :key="productId"
                             :product="getProduct(productId)"
                             :initialQuantity="1"
                             extraClasses="product--card"></product-list-item>

        </div>
      </div>
    </div>
    <div v-if="!ready">
      <loader></loader>
    </div>
    <banner></banner>
  </div>
</template>

<script>
import ProductListItem from './ProductListItem.vue'
import Loader from './Loader.vue'
import Banner from './Banner.vue'

export default {
  components: {
    Loader,
    Banner,
    ProductListItem},
  name: 'ProductList',
  mounted () {
    this.syncProducts()
  },
  data () {
    return {
      ready: false
    }
  },
  computed: {
    products () {
      return [...this.$store.state.productsList]
    }
  },
  methods: {
    syncProducts () {
      this.$store.dispatch('syncProducts')
        .then(() => {
          this.ready = true
        })
        .catch(err => {
          console.log(err)
          this.$modal.showCommonError()
        })
    },
    getProduct (id) {
      return this.$store.state.products[id]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ProductList.vue?3d860424